export default {"src":"/_next/static/media/download-icon-white.72614595.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};